import { FC, useRef } from 'react';
import './style.scss';
import { Row, Col } from 'antd';
import moment from 'moment';
import { NET, OTHER } from '../enum';

interface PropsType {
    data: Record<string, any>;
    options: Record<string, any>[];
}

const List: FC<PropsType> = ({ data = {}, options = [] }) => {
    const toPdfRef = useRef<HTMLDivElement>(null);

    function findName(val: string): string {
        const [item] = options.filter(({ dictBn }) => dictBn === val);
        return item?.name || '';
    }

    function getMediaOptions() {
        const data = options.filter(({ type }) => type === 'media');
        return data.map(({ name, dictBn }) => ({
            label: name,
            value: dictBn
        }));
    }
    const media = data?.media || [];
    const strLength = (data.subject || '').length;
    const isMax = strLength > 400;
    const fontSize = strLength < 500 ? '16px' : strLength < 1350 ? '14px' : '12px';

    return (
        <div className={['pdf-box', isMax ? 'pdf-box-max' : null].join(' ')} ref={toPdfRef}>
            <div style={{ textAlign: 'right', paddingRight: 15 }}>申请受理号 _______________</div>
            <h1>四川省医疗广告审查申请表</h1>
            <div style={{ textAlign: 'right', paddingRight: 15, paddingBottom: 15 }}>
                申请日期：{moment(new Date()).format('YYYY年MM月DD日')}
            </div>
            <div className='pdf-body'>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        医疗机构
                        <br />
                        第一名称
                    </Col>
                    <Col span={8} className='ant-col-c'>
                        {data.orgName || ''}
                    </Col>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        发证卫生
                        <br />
                        行政部门
                    </Col>
                    <Col className='ant-col-c' span={8}>
                        {data.department || ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='ant-col-c'>
                        《医疗机构执业许可证》登记号
                    </Col>
                    <Col span={8} className='ant-col-c'>
                        {data.registerBn || ''}
                    </Col>
                    <Col span={12}>
                        <Row className='ant-row-c'>
                            <Col span={8} className='ant-col-c p4i'>
                                法人名称
                                <br />
                                (主要负责人)
                            </Col>
                            <Col span={16} className='ant-col-c'>
                                {data.legalPerson || ''}
                                <br />
                                {data.principal ? `(${data.principal})` : ''}
                            </Col>
                        </Row>

                        <Row>
                            <Col span={8} className='ant-col-c'>
                                身份证号
                            </Col>
                            <Col span={16} className='ant-col-c'>
                                {data.idCard || ''}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        校验有效期限
                    </Col>
                    <Col span={20} className='ant-col-c'>
                        {data.startValidDate || ''} -- {data.endValidDate || ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        医疗机构地址
                    </Col>
                    <Col span={20} className='ant-col-c'>
                        {data.address || ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        所有制形式
                    </Col>
                    <Col span={8} className='ant-col-c'>
                        {data.ownership || ''}
                        {/* {findName(data.ownership) || ''} */}
                    </Col>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        医疗机构类别
                    </Col>
                    <Col className='ant-col-c' span={8}>
                        {findName(data.category_wj) || ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        诊疗科目
                    </Col>
                    <Col span={20} className='ant-col-c' style={{ fontSize: fontSize }}>
                        {data.subject || ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        床位数
                    </Col>
                    <Col span={8} className='ant-col-c'>
                        {data.bed || ''}
                    </Col>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        接诊时间
                    </Col>
                    <Col className='ant-col-c' span={8}>
                        {data.receptionTime ? data.receptionTime.join(' -- ') : ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        联系电话
                    </Col>
                    <Col span={8} className='ant-col-c'>
                        {data.phone || ''}
                    </Col>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        邮 编
                    </Col>
                    <Col className='ant-col-c' span={8}>
                        {data.zipCode || ''}
                    </Col>
                </Row>

                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        发布媒体类别
                    </Col>
                    <Col
                        span={8}
                        className='ant-col-c'
                        style={{ flexWrap: 'inherit', justifyContent: 'start' }}
                    >
                        {getMediaOptions().map(({ label, value }, index) => (
                            <span
                                key={index}
                                className={[
                                    'check-box',
                                    data?.media && data?.media?.includes(value) ? 'selected' : null
                                ].join(' ')}
                                style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
                            >
                                {value === NET && media.includes(value) && !!data.publish
                                    ? `${label}`//(${data.publish})
                                    : value === OTHER && media.includes(value) && !!data.other
                                    ? `${label}(${data.other})`
                                    : label}
                            </span>
                        ))}
                    </Col>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        广告时长(秒)
                    </Col>
                    <Col className='ant-col-c' span={8}>
                        {data.adDuration || ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        提交申请
                        <br />
                        材料目录
                    </Col>
                    <Col
                        span={20}
                        className='ant-col-c'
                        style={{ textAlign: 'left', justifyContent: 'start' }}
                    >
                        1、广告成品样件
                        <br />
                        2、医疗机构执业许可证正副本/备案诊所证/诊所备案凭证
                        <br />
                        3、医疗广告审查申请表
                        <br />
                        4、医疗广告成品样件表
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        经办人
                    </Col>
                    <Col span={8} className='ant-col-c'>
                        {data.contactName || ''}
                    </Col>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        身份证号
                    </Col>
                    <Col className='ant-col-c' span={8}>
                        {data.contactIdCard || ''}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        联系电话
                    </Col>
                    <Col span={8} className='ant-col-c'>
                        {data.contactPhone || ''}
                    </Col>
                    <Col span={4} className='pdf-item-lable ant-col-c'>
                        电子邮箱
                    </Col>
                    <Col className='ant-col-c' span={8}>
                        {data.contactEmail || ''}
                    </Col>
                </Row>
            </div>
            <br />
            <div style={{ marginTop: '15px', overflow: 'hidden', padding: '0 15px' }}>
                <div style={{ float: 'left' }}>法定代表人签名: _______________</div>
                <div style={{ float: 'right', paddingRight: '15px' }}>医疗机构(盖章)</div>
            </div>
            <div style={{ marginTop: '15px', padding: '0 30px', overflow: 'hidden' }}>
                <div style={{ float: 'right' }}>
                    <span>年</span>
                    <span style={{ marginLeft: '30px' }}>月</span>
                    <span style={{ marginLeft: '30px' }}>日</span>
                </div>
            </div>
            <br />
            <div>
                注：填报四川省医疗广告审查申请表时应一并填写四川省医疗广告成品样件表。
            </div>
        </div>
    );
};

export default List;
